import * as React from 'react';
import PropTypes from "prop-types";
import {buildUpdate} from "./sharedFunctions";
import {defaultRateLimit, requestTypes} from "./data";
import {RateLimit} from "./RateLimit";

export class RateLimits extends React.Component {
  static propTypes = {
    rateLimit: PropTypes.object,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    onAdd: PropTypes.func,
    disableRequestTypeSelection: PropTypes.bool,
  }

  onSelectRequestType = (e) => {
    return this.props.onChange(buildUpdate('value',{'request':e.target.value},null,true))
  }

  render() {
    const {rateLimits, onChange, onRemove, onAdd, availableRequestTypes} = this.props
    const {request, limits} = rateLimits
    const key=this.key

    return (
      <table className="table instant-audit-config-editor__table instant-audit-config-editor__table--indented">
        <tbody>
        <tr>
          <td colSpan="2">
            <h5 className="badge badge-success">Rate Limit:</h5>
          </td>
          <td colSpan="2">
            <span className="fas fa-trash-alt fa-lg pull-right instant-audit-config-editor__button--delete" onClick={() => onRemove(buildUpdate('value',null,null,true))}></span>
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <label htmlFor={'config-' + key + '-requestType'}>Request Type:</label>{/*TODO: fix these htmlFor's to be unique*/}
          </td>
          <td colSpan="2">
            <select disabled={availableRequestTypes.length === 0} className="form-control pull-right" onChange={this.onSelectRequestType} value={request}>
              {requestTypes.map( type => {
                return <option key={key + '-request-type-' + type} value={type}>{type}</option>
              })}
            </select>
          </td>
        </tr>
        <tr>
          <td colSpan="2"></td>
          <td colSpan="2">
            <button className="btn btn-secondary pull-right full-width"
                    onClick={() => onAdd({limits:{value: defaultRateLimit, isFinal:true}})}>
              <span className="far fa-plus"></span> Add Limit
            </button>
          </td>
        </tr>
        {limits.filter(limit => !limit.deleted).length === 0 && <tr><td colSpan="4">
          <div className="alert alert-danger"><span className="fas fa-exclamation-triangle"></span> Warning: No Limits are defined.  Default rate limits will be applied!</div>
        </td></tr>}
        {limits.map( (rateLimit,index) => {
          return (<RateLimit key={key+'-rate-limit-'+index}
                             rateLimit={rateLimit}
                             onAdd={(value) => onAdd({limits:value, index})}
                             onChange={(value) => onChange({limits:value, index})}
                             onRemove={(value) => onRemove({limits : value, index})}/>)
        })}
        </tbody>
      </table>

    )
  }
}
